import { observable, computed, action} from 'mobx';

export default class ScenarioStore {

    @observable currentScenario;
    @observable script = [];
    @observable pathPopupStatus = false;
    @observable active = false;

    default = {type:'default'};

    @action openPathPopup(item=[],active = false){
        this.active = active;
        this.pathPopupStatus = true;
        if(active){
            this.currentScenario = item;
            this.script = this.script.concat(...item)
        }else{
            this.script = this.script.concat(item, this.default)
        }

    }

    @action setDefaultScript(){
        this.script.splice(1,this.script.length-1, this.default);
    }

    @action closePathPopup(){
        this.script = [];
        this.pathPopupStatus = false;
        this.active = false
    }

    @action addScriptElem(elem,id){
        this.script.splice(id+1,0,elem)
    }

    @action setLastElem(elem){
      this.script.splice(this.script.length-1,1,elem);
    }

    @action deleteElementFromScript(id){
        if(id===this.script.length-1){
            this.setLastElem(this.default)
        }else{
            this.script.splice(id,1)
        }
    }

    @action setScenario(){
        if(this.active && this.script.length <=2 && this.script[this.script.length-1].type !== 'output' && this.script[this.script.length-1].type !== 'silo' && this.script[this.script.length-1].type !== 'hopper'){
            this.currentScenario.forEach((item,i)=>{
                if(item.type === 'cleaning' || item.type === 'drying'){
                    item.setUnit();
                }
                if((item.type === 'hopper' || item.type ==='silo') && (this.currentScenario.length-1) !== i){
                    item.initScenario([],0)
                }
            });
            this.script[0].initScenario([],-1);
        }else{
            this.script[0].initScenario(this.script,1);
        }
        this.closePathPopup();
    }

    @computed get getIsActiveSetScenarioButton(){
        return (this.active && this.script.length <=2 || (this.script.length > 1 &&
            (this.script[0].type === 'bunker' || this.script[0].type === 'silo' || this.script[0].type === 'hopper' ) &&
            (this.script[this.script.length-1].type === 'output' || this.script[this.script.length-1].type === 'silo' || this.script[this.script.length-1].type === 'hopper'))
        )
    }
}


// WEBPACK FOOTER //
// ./src/shared/stores/scenario.js